export default __webpack_public_path__ + "static/media/faq.54cf3743.jpg";